import React from "react";
import "./ButtonDownload.scss";

export default function ButtonDownload({ text, className, href, newTab, downloadName }) {
  return (
    <div className={className}>
      <a
        className="main-button"
        href={href}
        target={newTab ? "_blank" : undefined}
        rel="noopener noreferrer"
        download={downloadName}
      >
        {text}
      </a>
    </div>
  );
}
